// extracted by mini-css-extract-plugin
module.exports = {"outer":"_26BFG","detail":"_2jsco","stepsWrapper":"_2TqHO","steps":"_3ejSn","stepdetail":"_35gv1"};